import Reflux from 'reflux';

const CodecTypesActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default CodecTypesActions;



// WEBPACK FOOTER //
// ./src/actions/codecs/CodecTypesActions.js